import { CategoryAppliesTo, CategoryStatus } from '../enums';
import { z } from 'zod';
import { Translation } from './translation';

export const UpdateCategoryDto = z
  .object({
    status: z.enum([CategoryStatus.ARCHIVED, CategoryStatus.ACTIVE]).optional(),
    translations: z.array(Translation.optional()),
    appliesTo: z.array(z.nativeEnum(CategoryAppliesTo)).optional(),
  })
  .strict();

export type ApiUpdateCategoryDto = z.infer<typeof UpdateCategoryDto>;

export const CreateCategoryDto = z.object({
  status: z.enum([CategoryStatus.ARCHIVED, CategoryStatus.ACTIVE]).optional(),
  appliesTo: z.array(z.nativeEnum(CategoryAppliesTo)).optional(),
  translations: z.array(Translation),
});

export type ApiCreateCategoryDto = z.infer<typeof CreateCategoryDto>;
